var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.nodeError)?_c('Notification',{staticClass:"notification--danger error"},[_c('p',[_vm._v("A problem occurred while trying to start the IPFS node:")]),_vm._v(" "),_c('pre',{staticClass:"pre"},[_c('code',[_vm._v(_vm._s(_vm.message))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }